import {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {useForm} from 'react-hook-form';
import './checkout.css';

const mapDispatchToProps = () => ({});
const mapStateToProps = state => ({
  cart: JSON.parse(localStorage.getItem("cart")) || state.changeCart,
  products: JSON.parse(localStorage.getItem("products")) || state.changeProducts
});


const Checkout = ({cart, products}) => {
  const {marketpay} = window.document;
  const getInfo = (db, item) => {
		let productInfo = db.filter(({title}) => item===title)[0];
		if (typeof(productInfo) === 'undefined') {
			productInfo = {
				title: item,
				price: 0,
				category: "",
				subcategory: "",
				description: "",
				link: ""
			}
		}
		return productInfo;
	}

  const {register, handleSubmit} = useForm();

  useEffect(() => {
    const cardForm = marketpay.cardForm({
      amount: cart[0].reduce((curr, {quantity, item}) => {
        return curr + (getInfo(products, item).price*quantity)
      }, 0).toString(),
      form: {
        id: "form-checkout",
        cardholderName: {
          id: "form-checkout__cardholderName",
          placeholder: "Titular de la tarjeta",
        },
        cardholderEmail: {
          id: "form-checkout__cardholderEmail",
          placeholder: "Correo electronico del titular de la tarjeta",
        },
        cardNumber: {
          id: "form-checkout__cardNumber",
          placeholder: "Número de la tarjeta",
        },
        cardExpirationDate: {
          id: "form-checkout__cardExpirationDate",
          placeholder: "Data de vencimiento (MM/YYYY)",
        },
        securityCode: {
          id: "form-checkout__securityCode",
          placeholder: "Código de seguridad",
        },
        identificationType: {
          id: "form-checkout__identificationType",
          placeholder: "Tipo de documento",
        },
        identificationNumber: {
          id: "form-checkout__identificationNumber",
          placeholder: "Número de documento",
        },
        issuer: {
          id: "form-checkout__issuer",
          placeholder: "Banco emisor",
        },
        installments: {
          id: "form-checkout__installments",
          placeholder: "Cuotas",
        }
      },
      callbacks: {
        onFormMounted: () => {},
        onSubmit: handleSubmit(async (data) => {
          const {
            amount,
            cardholderEmail,
            identificationNumber,
            identificationType,
            issuerId,
            paymentMethodId,
            token,
          } = cardForm.getCardFormData();
          /*const non_necessary = {
          packageMethod: data.packageMethod,
          reference: data.reference,
          email: data.email,

          }
          */
          const request = {
            token,
            issuer_id: issuerId,
            payment_method_id: paymentMethodId,
            transaction_amount: Number(amount),
            installments: 1,
            description: "Compra",
            statement_descriptor: "COMPRAVALENTINA",
            payer: {
              first_name: data.firstName,
              last_name: data.lastName,
              email: cardholderEmail,
              identification: {
                type: identificationType,
                number: identificationNumber,
              }
            },
            additional_info: {
              items: cart[0].reduce((curr, {item, quantity}) => {
                curr.push({
                  id: item,
                  title: item,
                  description: getInfo(products, item).description,
                  category_id: getInfo(products, item).category,
                  quantity: quantity,
                  unit_price: Number(getInfo(products, item).price)
                });
                return curr;
              }, []),
              payer: {
                first_name: data.firstName,
                last_name: data.lastName,
                phone: {
                  number: data.phoneNumber
                }
              }
            },
          };
          try {
            const creditCardStatus = await fetch("https://pasteleriavalentina-server.herokuapp.com/pay", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(request),
            }).then(response => response.json());
            console.log(creditCardStatus);
          } catch(err) {
            console.log(err);
          }
        })
      },
    });

  }, []);

  return (
    <div className={"outer"}>
      <form id="form-checkout">
       <input type="text" name="cardNumber" id="form-checkout__cardNumber"
         {...register("cardNumber")}/>
       <input type="text" name="cardExpirationDate" id="form-checkout__cardExpirationDate"
         {...register("expirationDate")}/>
       <input type="text" name="cardholderName" id="form-checkout__cardholderName"
         {...register("cardHolderName")}/>
       <input type="email" name="cardholderEmail"
         id="form-checkout__cardholderEmail"
         placeholder={"Correo electronico del titular de la tarjeta"}
         {...register("cardHolderEmail")}/>
       <input type="text"
         name="securityCode"
         id="form-checkout__securityCode"
         {...register("securityCode")}/>
       <select name="installments" id="form-checkout__installments"></select>
       <select name="issuer" id="form-checkout__issuer"></select>
       <select name="identificationType" id="form-checkout__identificationType"
         {...register("identificationType")}></select>
       <input type="text" name="identificationNumber"
         id="form-checkout__identificationNumber"
         {...register("identificationNumber")}/>
       <input type={"text"}
         name={"firstName"}
         id={"form-checkout__firstName"}
         placeholder={"First Name"}
         {...register("firstName")}/>
       <input type={"text"}
         name={"lastName"}
         id={"form-checkout__lastName"}
         placeholder={"Last Name"}
         {...register("lastName")}/>
       <select type={"text"}
         name={"packageMethod"}
         id={"form-checkout__packageMethod"}
         {...register("packageMethod")}>
         <option value={"delivery"}>Delivery</option>
         <option value={"recojo"}>Recojo en tienda</option>
       </select>
       <input type={"text"}
         name={"phoneNumber"}
         id={"form-checkout__phoneNumber"}
         placeholder={"Phone Number"}
         {...register("phoneNumber")}/>
       <input type={"text"}
         name={"email"}
         id={"form-checkout__email"}
         placeholder={"Correo Electronico"}
         {...register("email")}/>
       <input type={"text"}
         name={"reference"}
         id={"form-checkout__reference"}
         placeholder={"Reference"}
         {...register("reference")}/>
       <button type="submit" id="form-checkout__submit">Pagar</button>
      </form>
    </div>
  )
  /*
  Needed fields:
  4. Delivery District (dependent).
  5. Pickup/Delivery Date-Time.
  11. Destiny type (casa, condominio, edificio).
  */
};

export default connect(mapStateToProps, mapDispatchToProps)(Checkout);
